(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-pdp-direct-actions-p1"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.AWPdpDirectActionsP1?.version) return;

  const normalize = (value = '') => String(value || '').trim().toLowerCase();

  const readJson = (key, fallback = {}) => {
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return fallback; }
  };

  const writeJson = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-aw-pdp-config-link]');
    if (!link) return;

    const root = link.closest('[data-aw-pdp-direct-actions]');
    if (!root) return;

    const platform = String(root.dataset.platform || '').trim();
    if (!platform) return;

    const platformLabel = String(root.dataset.platformLabel || platform).trim();
    const modelHandle = String(root.dataset.modelHandle || '').trim();
    const modelLabel = String(root.dataset.modelLabel || '').trim();
    const previous = readJson('aw_airsoft_configurator', {});
    const samePlatform = normalize(previous.platform) === normalize(platform);
    const selected = samePlatform && Array.isArray(previous.selected) ? previous.selected : [];

    const next = {
      ...previous,
      step: 3,
      name: samePlatform && previous.name ? previous.name : 'Configuration ' + platformLabel,
      savedId: '',
      platform,
      platformLabel,
      manufacturer: samePlatform ? String(previous.manufacturer || '') : '',
      type: samePlatform ? String(previous.type || '') : '',
      goal: samePlatform ? String(previous.goal || '') : '',
      category: '',
      query: '',
      sort: 'compatibility',
      selected
    };

    writeJson('aw_airsoft_configurator', next);
    writeJson('aw_airsoft_context_v1', {
      version: 1,
      platform,
      platformLabel,
      manufacturer: next.manufacturer,
      manufacturerLabel: '',
      type: next.type,
      typeLabel: '',
      model: modelLabel,
      modelLabel,
      modelHandle,
      source: 'pdp-direct-action',
      updatedAt: new Date().toISOString()
    });

    try {
      localStorage.setItem('aw_selected_platform', platform);
      if (!samePlatform) {
        localStorage.removeItem('aw_selected_manufacturer');
        localStorage.removeItem('aw_selected_replica_type');
      }
    } catch (_) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'aw_pdp_direct_configurator',
        platform,
        model: modelHandle || modelLabel || ''
      });
    } catch (_) {}
  }, true);

  window.AWPdpDirectActionsP1 = {
    version: '1.0.0',
    policy: 'single-platform-prefill-only;no-compatibility-inference;preserve-selection-only-on-same-platform'
  };
})();
  } catch(e) { console.error(e); }
})();

})();
